import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
  time: 0,
  isLoading: false,
};

export const hyperVergeSlice = createSlice({
  name: 'hyperverge',
  initialState,
  reducers: {
    getHyperToken: (state, action) => {
      state.isLoading = true;
    },
    saveHyperToken: (state, action: any) => {
      state.token = action.payload.token;
      state.time = Date.now();
      state.isLoading = false;
    },
    validateKyc: (state, payload) => {},
    checkKycStatus: (state, payload) => {},
  },
});

export const { getHyperToken, saveHyperToken, validateKyc, checkKycStatus } =
  hyperVergeSlice.actions;
export default hyperVergeSlice.reducer;
